module.exports = __webpack_public_path__ + "static/Sample-6-25e4dbad13e4ccde7bf70648b0a6a610.png";